<template>
  <div class="container-fluid pt-0 mt-0">
    <AddDestination
      v-if="showModal"
      :show="showModal"
      :onCancel="closeModal"
      @showSuccessPopup="handleSuccessPopup"
    />

    <DeleteModal
      :show="showDelete"
      @submit="doDelete"
      @close="closeDelete"
      :name="$t('destination')"
    />

    <EditDestination
      v-if="editDestinatonModal"
      :show="editDestinatonModal"
      v-on:closeDestinationOriginModal="editDestinatonModal = false"
      :destination="editedDestination"
      @showSuccessPopup="handleSuccessPopup"
    />

    <loading
      :active.sync="isLoading"
      :is-full-page="fullPage"
      background-color="#f3f3f3"
      :opacity="0.8"
      loader="bars"
    ></loading>

    <SuccessModal
      :show="showSuccessPopup"
      @close="showSuccessPopup = false"
      :msg="successMsg"
      :heading="successHeading"
    />

    <div
      style="
            background-color: #fff;
            max-height: 40rem;
            overflow-y: auto;
            width: 100%;
            height: fit-content;
          "
    >
      <div class="card-body" style="overflow-x: auto; width: 100%">
        <div class="header d-flex justify-content-between align-items-center">
          <p>{{ $t("destination") }}</p>
          <TableSearch @handleSearch="handleSearch" />
        </div>

        <div class="row">
          <div class="col-md-12">
            <div ref="content" class="table-responsive">
              <table id="order-listing" class="table table-hover display">
                <thead style="background-color: rgba(240, 244, 251, 0.6)">
                  <tr>
                    <th
                      :key="index"
                      v-for="(column, index) in tableColumns"
                      @click="sortBy(column[1])"
                      style="cursor: pointer; text-align: left"
                    >
                      {{ column[0] }}
                      <span class="arrow"></span>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(destination, index) in paginatedData"
                    class="user-row"
                    style="border-bottom: unset"
                    :key="index"
                    :class="{
                      'data-table-bg': index % 2 !== 0,
                    }"
                  >
                    <td style="text-transform: capitalize;">
                      {{ destination.name }}
                    </td>

                    <td>{{ destination.region }}</td>

                    <td>{{ destination.personOfContact }}</td>

                    <td>
                      {{ destination.country }}
                    </td>

                    <td>
                      {{ destination.address.name }}
                    </td>

                    <td>
                      <div class="d-flex align-items-center col-gap-1">
                        <span
                          class="cursor-pointer"
                          @click="editdestination(destination)"
                        >
                          <IconEdit />
                        </span>
                        <span
                          class="cursor-pointer"
                          @click="openDelete(destination.id)"
                        >
                          <IconDelete />
                        </span>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <Pagination
              :pageCount="pageCount"
              :data="paginatedData"
              :sizeperpage="sizeperpage"
              :pageNumber="pageNumber"
              :pages="pages"
              @goToLastPage="goToLastPage"
              @nextPage="nextPage"
              @handlePageChange="handlePageChange"
              @goToFirstPage="goToFirstPage"
              @prevPage="prevPage"
              @onchange="onchange"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import TableSearch from "../../../components/TableSearch.vue";
import tableMixin from "../../../mixins/tableMixinWithBackend";
import Pagination from "../../../components/PaginationNew.vue";
import IconEdit from "../../../components/Iconsvg/IconEditUser.vue";
import IconDelete from "../../../components/Iconsvg/IconDeleteUser.vue";

import AddDestination from "../../Modals/AddDestination.vue";
import DeleteModal from "../../Modals/DeleteModal.vue";
import EditDestination from "../../Modals/EditDestination.vue";
import SuccessModal from "../../Modals/SuccessModal.vue";


import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import "intro.js/introjs.css";

import loadGoogleMapsApi from "load-google-maps-api";

export default {
  name: "ExportDispatchDestination",

  mixins: [tableMixin],

  props: {
    showModal: Boolean,
    closeModal: Function,
  },

  components: {
    Pagination,
    TableSearch,
    IconEdit,
    IconDelete,
    AddDestination,
    DeleteModal,
    EditDestination,
    Loading,
    SuccessModal
  },

  data() {
    return {
      showDelete: false,
      editDestinatonModal: false,

      sortOrders: {},

      dataTable: [],

      isLoading: true,

      fullPage: true,

      editedDestination: [],
      showSuccessPopup: false,

      successMsg: "",
      successHeading: "",
    };
  },

  computed: {
    ...mapGetters(["meta", "destinations"]),

    paginationMeta() {
      return this.meta;
    },
    tableColumns() {
      return [
        [this.$t("company"), "company"],
        [this.$t("region"), "region"],
        [this.$t("person-of-contact"), "person-of-contact"],
        [this.$t("country"), "country"],
        [this.$t("address"), "address"],
        [this.$t("action"), "column2"],
      ];
    },
  },
  mounted() {
    this.fetchDestinations(this.params);

    loadGoogleMapsApi({
      key: process.env.VUE_APP_GOOGLE_API_KEY,
      libraries: ["places", "drawing", "geometry"],
    });
  },
  methods: {
    ...mapActions(["getDestinations", "addDestination", "deleteDestination"]),
    handleSuccessPopup({ msg, heading }) {
      this.successMsg = msg;
      this.successHeading = heading;
      this.showSuccessPopup = true;
    },
    closeDelete() {
      this.showDelete = false;
    },
    doDelete() {
      this.isLoading = true;

      this.deleteDestination(this.id).then(() => {
        this.getDestinations();
        this.isLoading = false;
        this.showDelete = false;

        this.showSuccessPopup = true;

        this.successMsg = this.$t("deleted_destination_mssg");
        this.successHeading = this.$t("deleted_destination_heading");
      });
    },
    openDelete(id) {
      this.showDelete = true;
      this.id = id;
    },
    editdestination(destinationInfo) {
      this.editedDestination = [destinationInfo];
      this.editDestinatonModal = true;
    },
    doSearch() {
      let params = {
        ...this.params,
        keyword: this.searchQuery,
      };
      this.fetchDestinations(params);
    },
    fetchDestinations(params) {
      this.isLoading = true;
      this.getDestinations(params)
        .then(() => {
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
  },
  watch: {
    destinations: {
      handler: function() {
        this.dataTable = this.destinations;
      },
      deep: true,
    },
    params() {
      this.fetchDestinations(this.params);
    },
  },
};
</script>

<style scoped>
.header {
  margin-bottom: 1rem;
}

.header > p {
  font-size: 14px;
  font-weight: 700;
  line-height: 18.2px;
  color: rgba(64, 74, 87, 1);
  margin-top: 1rem;
}
</style>
